import { eTipoPermissao } from '@/enums/ePermissoes';

export default [
 {
  description: 'Licença',
  path: '/pessoal/peslicenca',
  name: 'peslicenca',
  component: () => import('@/views/pessoal/peslicenca/Index.vue'),
  meta: {
   permissions: [eTipoPermissao.LICENCASNOVO_MENU_1400701299],
  },
  goesToMenu: true,
 },
 {
  description: 'Cadastro de Licença',
  path: '/pessoal/peslicenca/cadastro/:id?',
  parent: 'peslicenca',
  name: 'peslicenca_create',
  component: () => import('@/views/pessoal/peslicenca/InclusaoEdicao.vue'),
  meta: {
   permissions: [eTipoPermissao.LICENCASNOVO_MENU_1400701299],
  },
  goesToMenu: true,
 },
]
